var map = {
	"./arrow.svg": "3694",
	"./calm-women.svg": "d5cc",
	"./control.svg": "9c3e",
	"./happiness.svg": "ed52",
	"./pause.svg": "0dbf",
	"./people.svg": "786b",
	"./relaxation.svg": "3204",
	"./shopping.svg": "c50b",
	"./space.svg": "b5ed",
	"./star.svg": "ab9b",
	"./tilda-white.svg": "2a66",
	"./tilda.svg": "229d",
	"./triangle.svg": "157a",
	"./warning.svg": "ac91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edb4";